<template>
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900 pb-36">
       <div class="sm:mx-auto sm:w-full sm:max-w-screen-sm">

           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight w-full sm:text-center">
                       Invite your team to <span class="border-b border-dashed border-gray-800">{{ account.name }}</span>.
                   </div>
                   <div class="sm:text-center text-gray-800 w-full">
                       Teammates can easily access secure podcasts. You can do this at any time later, too. 🖖
                   </div>
                   <MultiInput v-model:form="form" />
                   <div v-if="sharedInvite" class="w-full pt-4 flex flex-col space-y-2.5">
                       <div class="text-lg font-medium">
                           Invite link
                       </div>
                       <div class="w-full flex items-center bg-gray-300 rounded-lg">
                           <input class="w-full bg-gray-300 rounded-lg p-5 pr-0 text-xl text-gray-700" :value="inviteLink">
                           <div class="shrink-0">
                               <div @click="copy">
                                   <div v-if="showTooltip" class="">
                                       <div class="relative w-full flex items-center justify-center">
                                           <div class="flex space-x-1 -translate-y-1/2 mb-2 items-center text-white absolute w-screen max-w-[8rem] bg-regal-blue-900 rounded-md p-3 text-sm font-medium">
                                               <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                                               <div class="">
                                                   Link copied
                                               </div>
                                           </div>
                                           <div class="absolute -bottom-0.5 w-full flex items-center justify-center">
                                               <div class="w-3 h-3 bg-regal-blue-900 rotate-45 rounded-xs">

                                               </div>
                                           </div>
                                       </div>
                                   </div>
                                   <div>
                                       <div class="flex space-x-1 p-3.5 m-1.5 cursor-pointer hover:bg-white rounded-md">
                                           <div class="">
                                               <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                                           </div>
                                           <div class="">
                                               Copy link
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                       <div class="text-sm font-medium text-gray-800 flex space-x-1">
                           <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                           <div class="">
                               Anyone can use this link to join <span class="font-bold">{{ account.name }}</span>. You can also choose to <span @click="deleteInvite" class="text-red-600 cursor-pointer hover:underline">deactivate</span> it.
                           </div>
                       </div>
                   </div>

               </div>
           </div>

       </div>
   </div>

   <OnboardingFooter :steps="steps" :form="form" />
</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import OnboardingFooter from '@/Shared/OnboardingFooter'
    import axios from 'axios'
    import { ref } from 'vue'
    import MultiInput from '@/Shared/MultiInput'

    export default {
        setup(props) {
            const form = useForm({
                emails: [],
                incompleteEmail: null,
            })
            const inviteLink = ref('')
            const sharedInvite = ref(null)
            const showTooltip = ref(false)
            const emailInputFocused = ref(false)
            return { form, inviteLink, sharedInvite, showTooltip, emailInputFocused }
        },
        props: {
            account: Object,
            steps: Object
        },
        components: { InlineError, OnboardingFooter, MultiInput },
        mounted() {
            this.getInviteUrl()
        },
        created() {
            const onKeydown = (e) => {
                if (e.keyCode === 8 || e.keyCode === 46) {
                    this.onBackspace()
                }
            }
            const focusChanged = (e) => {
                if (e.target === this.$refs.emailInput) {
                    this.emailInputFocused = true
                } else {
                    this.emailInputFocused = false
                }
            }
            document.addEventListener('focusin', focusChanged)
            document.addEventListener('keydown', onKeydown)
        },
        beforeDestroy() {
          document.removeEventListener('focusin')
          document.removeEventListener('keydown')
        },
        computed: {
            invalidEmails() {
                return this.form.emails.filter(email => email.valid === false)
            }
        },
        methods: {
            onInput() {
                const input = this.$refs.emailInput
                const lastChar = input.textContent.slice(-1);
                if (/\s/g.test(input.textContent) || lastChar == ',') {
                    if (this.isEmail(input.textContent.slice(0, -1)) && input.textContent.slice(0, -1) !== this.$page.props.auth.user.email) {
                        let email = this.isEmail(input.textContent.slice(0, -1))[0]
                        this.form.emails.push({ value: email, valid: true })
                        input.textContent = ''
                        input.focus()
                    } else {
                        this.form.emails.push({ value: input.textContent.slice(0, -1), valid: false})
                        input.textContent = ''
                        input.focus()
                    }
                }
                this.form.incompleteEmail = input.textContent
            },
            onPaste(e) {
                e.stopPropagation()
                e.preventDefault()
                let clipboardData = e.clipboardData || window.clipboardData
                let pastedData = clipboardData.getData('text/plain')
                let splitArray = pastedData.split(/[\s,]+/)
                let emailArray = []
                const input = this.$refs.emailInput

                splitArray.forEach((email, i) => {
                    if (this.isEmail(email)) {
                        this.form.emails.push({ value: email, valid: true })
                        input.textContent = ''
                    } else {
                        this.form.emails.push({ value: email, valid: false })
                        input.textContent = ''
                    }
                })
            },
            onBackspace() {
                if (this.emailInputFocused && this.$refs.emailInput.textContent == '') {
                    if (this.form.emails.length > 0) {
                        this.form.emails.pop()
                        return
                    }
                }
            },
            isEmail(email) {
                return String(email)
                    .toLowerCase()
                    .match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    );
            },
            deleteEmail(index) {
                this.form.emails.splice(index, 1)
                this.$refs.emailInput.focus()
            },
            clearInvalidEmails() {
                this.form.emails = this.form.emails.filter(email => email.valid)
            },
            deleteInvite() {
                this.$inertia.delete(route('invites.destroy', this.sharedInvite), {
                    onSuccess: (page) => {
                        this.sharedInvite = null
                    },
                })
            },
            async copy() {
                try {
                    await navigator.clipboard.writeText(this.inviteLink).then(fn => {
                        this.showTooltip = true
                        setTimeout(() => {this.showTooltip = false}, 1500);
                    });
                } catch(e) {
                    console.log(e);
                }
            },
            getInviteUrl() {
                axios.post('/invites', {
                        'type': 'shared',
                    })
                    .then((res) => {
                        this.inviteLink = res.data.inviteUrl
                        this.sharedInvite = res.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        }
    }
</script>
